// @file Vuex Store for showing Confirmation Dialog (e.g. for deleting padlets)
import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

// `type` should be name of action relative to root
interface AfterConfirmAction {
  type: string
  payload?: string
}
interface ConfirmationDialogState {
  isOpen: boolean
  title: string
  body: string
  confirmButtonText: string
  cancelButtonText: string
  afterConfirmActions: AfterConfirmAction[]
}

const ConfirmationDialogModuel: Module<ConfirmationDialogState, RootState> = {
  namespaced: true,
  state: {
    isOpen: false,
    title: '',
    body: '',
    confirmButtonText: '',
    cancelButtonText: '',
    afterConfirmActions: [],
  },
  mutations: {
    RESET_CONFIRMATION_DIALOG(state): void {
      state.isOpen = false
      state.title = ''
      state.body = ''
      state.confirmButtonText = ''
      state.cancelButtonText = ''
      state.afterConfirmActions = []
    },
    OPEN_CONFIRMATION_DIALOG(
      state,
      { title, body, confirmButtonText, cancelButtonText, afterConfirmActions }: ConfirmationDialogState,
    ): void {
      state.isOpen = true
      state.title = title
      state.body = body
      state.confirmButtonText = confirmButtonText
      state.cancelButtonText = cancelButtonText
      state.afterConfirmActions = afterConfirmActions
    },
  },
  actions: {
    openConfirmationDialog({ commit }, params): void {
      commit('OPEN_CONFIRMATION_DIALOG', params)
    },
    executeConfirmActions({ dispatch }, actions: AfterConfirmAction[]): void {
      actions.forEach((actionHash): void => {
        dispatch(actionHash.type, actionHash.payload, { root: true })
      })
    },
    confirm({ commit, dispatch, state }): void {
      dispatch('executeConfirmActions', state.afterConfirmActions)
      commit('RESET_CONFIRMATION_DIALOG')
    },
    cancel({ commit }): void {
      commit('RESET_CONFIRMATION_DIALOG')
    },
  },
}

export default ConfirmationDialogModuel
export { AfterConfirmAction, ConfirmationDialogState }
